<div class="file-upload">
  <div class="pb-2" *ngIf="formElementModel.label">
    {{ formElementModel.label + asterisk }}
  </div>
  <input
    type="file"
    class="file-input d-none"
    (change)="onFileSelected($event)"
    #fileUpload
    multiple
    [accept]="acceptedFileExtensions"
  />

  <button
    mat-button
    color="primary"
    class="upload-btn my-3"
    (click)="fileUpload.click()"
    [id]="'btn-' + formElementModel.id"
  >
    <mat-icon>attach_file</mat-icon>
    Attach documents here
  </button>

  <div class="row">
    <div class="col">
      <div class="upload-file-list mt-3" *ngFor="let file of files">
        <div class="row">
          <div class="col upload-filename">{{ file.name }}</div>
        </div>
        <div class="d-flex flex-row align-items-center">
          <mat-progress-bar
            class="progress-bar"
            [ngClass]="{ 'upload-success': file.success }"
            [color]="file.progressBarColor"
            [mode]="file.progressBarMode"
            [value]="file.uploadProgress"
            *ngIf="file.uploadProgress"
          ></mat-progress-bar>
          <button
            class="d-inline justify-content-center align-items-center mt-n2 delete-upload"
            type="button"
            (click)="handleFileRemoval(file.id)"
            id="removeFileAttachment{{ file.id }}"
            mat-icon-button
            matTooltip="Delete attachment"
            matTooltipShowDelay="500"
            tabIndex="-1"
          >
            <fa-icon class="primary" [icon]="['fas', 'trash']"></fa-icon>
          </button>
        </div>
        <div class="row">
          <div class="col upload-message">
            <span class="text-danger" *ngIf="file.error.onUpload"
              >The file could not be attached, please try again in a few
              minutes.</span
            >
            <span class="text-danger" *ngIf="file.error.fileSize"
              >The file is {{ file.size }}MB in size. Only files less than
              {{ maxUploadSize }}MB in size can be attached.</span
            >
            <span class="text-danger" *ngIf="file.error.fileType"
              >The file is in {{ file.extension }} format. Only
              {{ acceptedFileExtensions }} files can be attached.</span
            >
            <span class="text-danger" *ngIf="file.error.fileContent"
              >The file does not appear to be a valid {{ file.extension }} file.
              Please save it again and try re-attaching it.</span
            >
            <span class="text-danger" *ngIf="file.error.fileAmount">
              File not uploaded, limit of {{ maxFileAmount }} files has been
              reached.
            </span>
            <span class="text-success" *ngIf="file.success"
              >Upload successful.</span
            >
          </div>
        </div>
      </div>

      <mat-hint *ngIf="formElementModel.placeholder">{{
        formElementModel.placeholder
      }}</mat-hint>

      <app-validation-error
        [control]="control"
        [formElementModel]="formElementModel"
      >
      </app-validation-error>
    </div>
  </div>
</div>
